import { useMemo } from 'react';

import { getMeasurementPreferences } from '../lib/measurements';
import { useAuthStore } from '../store/authStore';

export function useMeasurementPreferences() {
  const measurementPreferences = useAuthStore((state) => state.user?.measurementPreferences);
  return useMemo(() => getMeasurementPreferences(measurementPreferences), [measurementPreferences]);
}
